import { cleanupExpiredMediaFiles } from "./file-cleanup";
import { logger } from "./logger";

/**
 * Setup cron jobs for background tasks
 */
export function setupCronJobs(): void {
  // Run file cleanup every hour
  const CLEANUP_INTERVAL = 60 * 60 * 1000; // 1 hour in milliseconds

  setInterval(async () => {
    try {
      logger.info("Running scheduled file cleanup...");
      const deletedCount = await cleanupExpiredMediaFiles();

      if (deletedCount > 0) {
        logger.info(`File cleanup completed: ${deletedCount} files deleted`);
      }
    } catch (error) {
      logger.error("Error in scheduled file cleanup:", error);
    }
  }, CLEANUP_INTERVAL);

  logger.info("Cron jobs initialized: File cleanup scheduled every hour");
}
